import script from "./componentDetails.vue?vue&type=script&lang=js"
export * from "./componentDetails.vue?vue&type=script&lang=js"

import "./componentDetails.vue?vue&type=style&index=0&id=99554586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99554586"]])

export default __exports__